import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import StyledButton from "../buttons/styledButton";
import Icon from "../icon";
import useFilterContext from "./context/useFilterContext";
import { Badge } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const FilterButton: React.FC = () => {
  const { toggleFilter, count } = useFilterContext();

  return (
    <Badge badgeContent={count} classes={{ badge: cssExports.filterCount }}>
      <StyledButton
        onClick={toggleFilter}
        size="sm"
        startIcon={<Icon icon={IconDefinitionConstants.WFilter} />}
        testId="filterButton"
      >
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Filter)}
      </StyledButton>
    </Badge>
  );
};

export default FilterButton;
